import { useMutation } from '@apollo/client';
import { keys } from 'lodash';
import { City } from '../../shared/types';
import { CITRIN_CREATE_CITIES, CreateCityRequest, CreateCityResponse } from '..';

type CreateMutationFunction = (request: City) => Promise<City>;
export const useCreateCityMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreateCityResponse, CreateCityRequest>(CITRIN_CREATE_CITIES);

    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createCity;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
